import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import { AuthContextProvider, LoaderContext } from '../../AuthContext/AuthContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { t } from 'i18next';
import NoResultFoundModel from '../../Components/NoDataFound/NoDataFoundModal';
import { GetPopolarPujaList, PujaDetailsBySlug } from '../../ApiServices/Puja/PujaApi';
import LoginPopUp from '../../Components/LoginPopup';
import ShareLinkModal from '../../Components/ShareLinkModal';
import { PujaShareMassage } from '../../middlewares/Utils';
import './PujaListPageDesign.css'
import PujaTabs from './PujaTabs';
import PujaPageSections from './PujaTabs';

import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCalendarAlt, faChevronLeft, faChevronRight, faVihara, faLocationDot } from '@fortawesome/free-solid-svg-icons';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import CountdownTimer from './CountdownTimer';
import HowItWorks from '../../Components/CommonSections/HowItWorks';
import LazySection from '../Home/LazySection';
import { height } from '@mui/system';
import DownloadApp from '../../Components/DownLoadApp/DownloadApp';
import PujaKitSubscriptionLandingPage from '../../Components/PujaKitSubscription/PujaKitSubscriptionLandingPage';
import SankalpPujasPackageList from '../SankalpPujas/SankalpPujasPackageList';
import ShareButton from './ShareButton';
import { pujaServiceID, pujaSubServiceID } from '../../Components/enum';
import HoroscopeBannerImg from "../../assets/images/new/banner-remid.jpeg";
import { faShareAlt } from "@fortawesome/free-solid-svg-icons"; // or faShareNodes if you prefer newer icon
import Breadcrumbs from '../../Components/Breadcrumb';
import PujaUnavailableModal from '../../Components/CommonSections/PujaUnavailableModal';
import { unavailablePujaMsg, unavailablePujaMsgHeader } from '../../Components/GlobalErrorMessage';
import PopularPujas from '../../Components/CommonSections/PopularPujas';
import favIcon from "../../assets/images/Fav.png"
import ExitIntentModal from '../ServicesLandingPage/ExitIntentModal';
const RemedyPujaDetails = () => {
    dayjs.extend(duration);

    const { isAuthenticated } = useContext(AuthContextProvider);
    const { setLoader, selectedLanguageID, formatToIndianCurrency, isLanguageUpdate } = useContext(LoaderContext);
    const { slug } = useParams();
    const location = useLocation();
    const [showModal, setShowModal] = useState(false);
    const currentUrl = window.location.href;
    const navigate = useNavigate();

    const [totalRecords, setTotalRecords] = useState(-1);
    const [FAQ, setFaq] = useState([]);
    const [showLoginModal, setShowLoginModal] = useState(null);
    const [modalRequestData, setModalRequestData] = useState(null);

    const [readMore, setReadMore] = useState(false);
    const [deityReadMore, setDeityReadMore] = useState(false);
    const [readMoreDetailed, setReadMoreDetailed] = useState(false);
    const maxChars = 500; // number of characters to show initially
    const DeityChars = 80; // number of characters to show initially

    const [pujaBannerHeaderName, setPujaBannerHeaderName] = useState(null);
    const [showPujaNotAvailableModal, setShowPujaNotAvailableModal] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState({})
    const [mainImage, setMainImage] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [pujaDetailsData, setPujaDetailsData] = useState({
        convenienceFee: null,
        pujaDetails: null,
        pujaDiscount: null,
        pujaId: null,
        pujaImageUrl: null,
        pujaName: null,
        pujaPrice: null,
        pujaSamagri: null,
        pujaSamagriPrice: null,
        CategoryType: null,
        metaTitle: null,
        metaDescription: null,
        OpenGraphtag: null,
        canonicalTag: null,
        ExtraMetaTag: null,
        shortDescription: null,
        keyFeature: null,
        PujaSlug: null,
        drySamagriPrice: null,
        WetSamagriPriceTaxAmount: null,
        WetSamagriPrice: null,
        DrySamagriPriceTaxAmount: null,
        DrySamagriPriceTaxPercent: null,
        WetSamagriPriceTaxPercent: null,

    });

    const [pujaListData, setPujaListData] = useState([]);
    const [showExitIntentModal, setShowExitIntentModal] = useState(false);

    const serviceData = {
        howItWorksMainHeading: "Receive Blessings of the Divine",
        howItWorks: [
            {
                howItWorksTitle: "Select Your Homam Puja",
                howItWorksDesc:
                    "Choose the Homam Puja you wish to perform, be it for peace, prosperity, health, housewarming, or any special occasion.",
            },
            {
                howItWorksTitle: "Book Your Ritual Easily",
                howItWorksDesc:
                    "Simply book your puja, and our experienced priests will conduct every ritual with devotion and authentic Vedic tradition.",
            },
            {
                howItWorksTitle: "Receive Divine Blessings",
                howItWorksDesc:
                    "Join the sacred ceremony, feel the positive vibrations, and invite blessings of health, happiness, and prosperity into your life.",
            },
        ],
    }
    let isRemedy = location?.state?.isRemedySubscription || location?.pathname.split("/").slice(0, 3).join("/") === "/service/subscription-remedy-puja-details";
    let isHomam = location?.state?.isHomamSubscription || location?.pathname.split("/").slice(0, 3).join("/") === "/service/subscription-homam-puja-details";


    useEffect(() => {

        const basePath = location?.pathname.split("/").slice(0, 3).join("/");
        if (basePath === "/service/subscription-remedy-puja-details") {
            isRemedy = true
        } else if (basePath === "/service/subscription-homam-puja-details") {
            isHomam = true
        }
        GetSlugPujaData()
    }, [])

    useEffect(() => {
        if (isLanguageUpdate) {
            GetSlugPujaData()

        }
    }, [isLanguageUpdate])

    useEffect(() => {
        if (selectedPackage?.price !== undefined && selectedPackage?.price !== null) {
            handleProceedToBookClicked()
        }
    }, [selectedPackage])


    // useEffect(() => {
    //     const path = location.pathname;

    //     const TARGET_PATH = "/service/puja-details/book-satyanarayan-puja";

       
    //     if (path === TARGET_PATH) {
    //         const modalClosed = sessionStorage.getItem("exit_modal_closed");

    //         const handleScroll = () => {
    //             if (!modalClosed && window.scrollY > 30) {
    //                 setShowExitIntentModal(true);
    //                 window.removeEventListener("scroll", handleScroll);
    //             }
    //         };

    //         window.addEventListener("scroll", handleScroll);

    //         return () => {
    //             window.removeEventListener("scroll", handleScroll);
    //         };
    //     } else {
          
    //         setShowExitIntentModal(false);
    //     }
    // }, [location.pathname]);


    const GetSlugPujaData = async () => {

        setLoader(true);
        try {
            const response = await PujaDetailsBySlug({
                pujaSlug: slug,
                applangID: selectedLanguageID
            });

            if (response?.statusCode === 200) {
                setLoader(false);
                const modalData = response?.responseData?.data;

                if (modalData === null || modalData === undefined) {
                    navigate("/*");
                }
                if (location?.state?.serviceName === "PujaAtTemple") {

                    let updatedPujaDetailsData = {
                        ...modalData,
                        pujaSubServiceID: pujaSubServiceID?.PujaAtTemple,
                        pujaServiceID: pujaServiceID?.Temple,

                    };
                    setPujaDetailsData(updatedPujaDetailsData)
                } else {
                    setPujaDetailsData(modalData)
                }
                if (modalData?.status === false) {
                    setShowPujaNotAvailableModal(true)
                } else {
                    setShowPujaNotAvailableModal(false)
                }

                setMainImage(modalData?.pujaImageUrl)
                if (modalData?.pujaName !== null && modalData?.pujaName !== undefined && modalData?.pujaName !== "") {
                    setTotalRecords(1)
                }
                if (modalData?.pujaSubServiceID === 1 && !isRemedy) {
                    setPujaBannerHeaderName("Remedy Puja");
                } else if (modalData?.pujaSubServiceID === 2 && !isHomam) {
                    setPujaBannerHeaderName("Homam Puja");
                } else if (isRemedy) {
                    setPujaBannerHeaderName("Subscription Remedy Puja");
                } else if (isHomam) {
                    setPujaBannerHeaderName("Subscription Homam Puja");
                } else if (modalData?.pujaSubServiceID === 5) {
                    setPujaBannerHeaderName("Pandit Puja");
                } else if (modalData?.pujaSubServiceID === 6) {
                    setPujaBannerHeaderName("Daily Pandit Puja");
                } else if (modalData?.pujaSubServiceID === 7) {
                    setPujaBannerHeaderName("Puja At Temple Details");
                }
                GetPopolarPujaListData(modalData?.pujaSubServiceID, modalData?.pujaServiceID,modalData?.pujaKeyID);

            } else {
                setLoader(false);
                setTotalRecords(0)
            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const handleProceedToBookClicked = () => {

        const userKeyID = localStorage.getItem("userKeyID")
        if (userKeyID !== null && userKeyID !== undefined && userKeyID !== "") {

            let updatedPujaDetailsData = {
                ...pujaDetailsData,

            };
            if (isRemedy || isHomam) {

                updatedPujaDetailsData = {
                    ...pujaDetailsData,
                    offlinePujaPrice: selectedPackage?.price,
                    offilePujaPriceWithAllCharges: selectedPackage?.price,
                    offlinePujaDiscountAmount: selectedPackage?.pujaDiscountAmount || 0,
                    onlinePujaPrice: null,
                    onlinePujaDiscountAmount: null,
                    pujaDiscount: selectedPackage?.discount,
                    pujaTypeID: 2,
                    title: selectedPackage?.title,
                    subTitle: selectedPackage?.subTitle,
                    timeLine: selectedPackage?.timeLine,
                    description: selectedPackage?.description,
                    pujaSubServiceID: isRemedy ? pujaSubServiceID?.SubscriptionRemedyPuja : pujaSubServiceID?.SubscriptionHomamPuja,
                    pujaServiceID: isRemedy ? pujaServiceID?.SankalpPuja : pujaServiceID?.SankalpPuja,
                    tempPujaSubPackageKeyID: selectedPackage?.tempPujaSubPackageKeyID
                };
            }

            // keep offlinePujaPrice untouched (no overwrite)

            setShowLoginModal(false);
            navigate("/service/puja-service/booking-form", {
                state: {

                    pujaDetailsData: updatedPujaDetailsData,

                },
            });
        } else {
            setShowLoginModal(true);
        }
    };


    const GetPopolarPujaListData = async (pujaSubServiceID, pujaServiceID,pujaKeyID) => {
        if (!pujaSubServiceID || !pujaServiceID) return;
        setLoader(true);
        try {
            const response = await GetPopolarPujaList(pujaServiceID, pujaSubServiceID, Number(selectedLanguageID));
            if (response?.statusCode === 200) {
                const data = response?.responseData?.data;
                const updatedList= data.filter(item=>item.pujaKeyID!==pujaKeyID)
                setLoader(false);
                setPujaListData(updatedList);
              
            }


        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const articleSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": pujaDetailsData?.MetaTitle,
        "description": pujaDetailsData?.MetaDescription,
        "image": pujaDetailsData?.imageURL || "default-image-url.jpg",
        "author": {
            "@type": "Organization",
            "name": "Myomnamo",
            "url": "https://www.myomnamo.com"
        },
        "publisher": {
            "@type": "Organization",
            "name": "Myomnamo",
            "logo": {
                "@type": "ImageObject",
                "url": "https://www.myomnamo.com"
            }
        },
        "datePublished": pujaDetailsData?.publishedDate || null,
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": pujaDetailsData?.canonicalURL
        }
    };

    const webPageSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": pujaDetailsData?.MetaTitle,
        "description": pujaDetailsData?.MetaDescription,
        "url": pujaDetailsData?.canonicalURL,
        "image": pujaDetailsData?.imageURL || "default-image-url.jpg",
        "inLanguage": "en",
        "publisher": {
            "@type": "Organization",
            "name": "Myomnamo",
            "url": "https://www.myomnamo.com"
        }
    };

    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.myomnamo.com"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Blog",
                "item": "https://www.myomnamo.com/services/book-puja"
            },
            {
                "@type": "ListItem",
                "position": 3,
                "name": pujaDetailsData?.MetaTitle,
                "item": pujaDetailsData?.canonicalURL
            }
        ]
    };



    const plainText = (() => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = pujaDetailsData.shortDescription;
        return tempDiv.innerText || tempDiv.textContent || "";
    })();



    const toggleReadMore = () => setReadMore(!readMore);
    const toggleDeityReadMore = () => setDeityReadMore(!deityReadMore);
    const toggleReadMoreDetails = () => setReadMoreDetailed(!readMoreDetailed);


    // ----------------------------------------------------------------------------
    const images = [
        pujaDetailsData?.pujaImageUrl,
        pujaDetailsData?.pujaImageUrl,
        pujaDetailsData?.pujaImageUrl,
        pujaDetailsData?.pujaImageUrl,

    ];


    const handleThumbnailClick = (image) => {
        setMainImage(image);
        setCurrentImageIndex(images.indexOf(image));
    };

    const handleNext = () => {
        const nextIndex = (currentImageIndex + 1) % images.length;
        setCurrentImageIndex(nextIndex);
        setMainImage(images[nextIndex]);
    };

    const handlePrev = () => {
        const prevIndex = (currentImageIndex - 1 + images.length) % images.length;
        setCurrentImageIndex(prevIndex);
        setMainImage(images[prevIndex]);
    };




    // ------------------------------------
    const target = dayjs(
        `${pujaDetailsData?.pujaDate?.split(" ")[0]} ${pujaDetailsData?.pujaTime}`,
        // adjust format here to match the API date format
        "M/D/YYYY HH:mm:ss"
    );

    const getTimeLeft = () => {
        const diff = target.diff(dayjs());
        if (diff <= 0) {
            return { days: 0, hours: 0, minutes: 0, seconds: 0, completed: true };
        }
        const d = dayjs.duration(diff);
        return {
            days: d.days(),
            hours: d.hours(),
            minutes: d.minutes(),
            seconds: d.seconds(),
            completed: false,
        };
    };

    const [timeLeft, setTimeLeft] = useState(getTimeLeft);

    // useEffect(() => {
    //     const id = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    //     return () => clearInterval(id);
    // }, [target]);

    const pad = (n) => n.toString().padStart(2, "0");


    const PujaShareMessage = `Book temple pujas from the comfort of your home. Choose your temple, date, priest and then leave the rest to us. No stress, just devotion. Experience a smooth, offline puja booking service today! Visit now: ${window.location.href}`;




    const handleWhatsappClick = () => {
        const encodedMessage = encodeURIComponent(PujaShareMassage);
        const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;

        // Open the WhatsApp link in a new tab
        window.open(whatsappUrl, '_blank');
    };

    let howItWorks = {}
    if (pujaDetailsData?.pujaSubServiceID === 5) {
        howItWorks = {
            howItWorksMainHeading: t("Receive Blessings of the Divine"),
            howItWorks: [
                {
                    howItWorksTitle: t("Select Your Puja"),
                    howItWorksDesc:
                        t("Choose the Puja you wish to perform, be it for peace, prosperity, health, housewarming, or any special occasion."),
                },
                {
                    howItWorksTitle: t("Book Your Ritual Easily"),
                    howItWorksDesc:
                        t("Simply book your puja, and our experienced priests will conduct every ritual with devotion and authentic Vedic tradition."),
                },
                {
                    howItWorksTitle: t("Receive Divine Blessings"),
                    howItWorksDesc:
                        t("Join the sacred ceremony, feel the positive vibrations, and invite blessings of health, happiness, and prosperity into your life."),
                },
            ],
        }
    } else {
        howItWorks = {
            howItWorksMainHeading: t("Receive Blessings of the Divine"),
            howItWorks: [
                {
                    howItWorksTitle: t("Select Your Puja"),
                    howItWorksDesc:
                        t("Choose the Puja you wish to perform, be it for peace, prosperity, health, housewarming, or any special occasion."),
                },
                {
                    howItWorksTitle: t("Book Your Ritual Easily"),
                    howItWorksDesc:
                        t("Simply book your puja, and our experienced priests will conduct every ritual with devotion and authentic Vedic tradition."),
                },
                {
                    howItWorksTitle: t("Receive Divine Blessings"),
                    howItWorksDesc:
                        t("Join the sacred ceremony, feel the positive vibrations, and invite blessings of health, happiness, and prosperity into your life."),
                },
            ],
        }
    }

    // utils/sharePuja.js
    const sharePujaDetails = async () => {
        const shareData = {
            title: pujaDetailsData?.pujaName,
            text: plainText || '',
            url: window.location.href,
        };

        try {
            // Fallback: share without image
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                alert("Sharing not supported on this device");
            }
        } catch (error) {
            console.error("Error sharing:", error);
        }
    };


    return (
        <>
            <section className="page-header" style={{ paddingBottom: '35px' }}>
                <div
                    className="page-header__bg horoscope-banner-responsive"
                    style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
                ></div>
                <div className="container" style={{ display: 'block' }}>
                    <h2 className="page-header__title bw-split-in-left">{t(pujaBannerHeaderName)}</h2>
                    <div className='d-flex justify-content-center'>
                        <Breadcrumbs />
                    </div>
                </div>
            </section>

            {/* SEO Tags */}
            <Helmet>
                <link rel="icon" type="image/png" href={favIcon} />
                <title>{pujaDetailsData?.metaTitle}</title>
                <meta name="description" content={pujaDetailsData?.metaDescription} />
                <link rel="canonical" href={pujaDetailsData?.canonicalTag} />

                {/* Open Graph Tag */}

                {/* <!-- Open Graph tags --> */}
                <meta property="og:title" content={pujaDetailsData?.metaTitle} />
                <meta
                    property="og:description"
                    content={pujaDetailsData?.metaDescription}
                />
                <meta property="og:image" content={mainImage} />
                <meta
                    property="og:url"
                    content={`https://www.myomnamo.com/services/book-puja/${pujaDetailsData?.pujaSlug}`}
                />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Myomnamo" />
                <meta property="og:locale" content="en_IN" />

                {/* <!-- Twitter Card tags --> */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pujaDetailsData?.metaTitle} />
                <meta
                    name="twitter:description"
                    content={pujaDetailsData?.metaDescription}
                />
                <meta name="twitter:image" content={mainImage} />
                {/* {pujaDetailsData?.extraMetaTag} */}


                {/* Breadcrumb JSON-LD Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify(breadcrumbSchema)}
                </script>

                {/* WebPage JSON-LD Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify(webPageSchema)}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(articleSchema)}
                </script>

            </Helmet>
            {/* <ShareButton /> */}
            {totalRecords > 0 && (
                <>

                    <Container fluid className='pooja-remidy mt-10' style={{ maxWidth: "1200px" }} >


                        {/* Main Content Row */}
                        <Row className="justify-content-center mt-3">
                            {/* Left Column: Image Gallery */}
                            <Col md={6}>
                                <div className="position-relative d-flex justify-content-center">
                                    {/* Main Image */}
                                    {/* Navigation Arrows */}
                                    {/* <Button
                                    variant="light"
                                    className="position-absolute top-50 start-0 translate-middle-y rounded-circle p-2"
                                    onClick={handlePrev}
                                    style={{ zIndex: 2 }} // ensure button is clickable
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </Button> */}
                                    <Image src={mainImage || pandit} style={{ height: `${mainImage ? '' : "250px"}` }} className='img-fluid-custom' rounded />


                                    {/* <Button
                                    variant="light"
                                    className="position-absolute top-50 end-0 translate-middle-y rounded-circle p-2"
                                    onClick={handleNext}
                                    style={{ zIndex: 2 }} // ensure button is clickable
                                >
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </Button> */}
                                </div>

                                {/* Thumbnails */}
                                {/* <div className="d-flex justify-content-center mt-3 gap-2 flex-wrap">
                                {images.map((image, index) => (
                                    <div
                                        key={index}
                                        className={`thumbnail-wrapper ${mainImage === image ? 'active' : ''}`}
                                        onClick={() => handleThumbnailClick(image)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <Image src={image} className="thumbnail-image" />
                                    </div>
                                ))}
                            </div> */}

                                <div className='d-block  d-md-none'>
                                    <hr />
                                </div>
                            </Col>


                            {/* Right Column: Puja Details */}
                            <Col md={6} className=" mt-md-0">
                                <div className=" h-100">
                                    {/* Header */}
                                    {/* <div className="text-center py-2 seatsLeft">
                                    <p className="mb-0 fw-bold text-muted">Last day today!</p>
                                </div> */}
                                    <div className=" px-md-4">
                                        {/* Title and Subtitle */}
                                        <h3 className="mb-1 fw-bold">{pujaDetailsData?.pujaName}</h3>
                                        <p className="small mb-2 fw-bold" style={{ fontSize: "16px", color: '#efb423' }}>
                                            {deityReadMore ? pujaDetailsData?.benefits : pujaDetailsData?.benefits?.length > DeityChars ? `${pujaDetailsData?.benefits.substring(0, DeityChars)}...` : pujaDetailsData?.benefits}
                                            {pujaDetailsData?.benefits?.length > DeityChars && (
                                                <span
                                                    onClick={toggleDeityReadMore}
                                                    // className="btn-fancy"
                                                    style={{ color: '#a52444', cursor: 'pointer' }}
                                                >
                                                    {deityReadMore ? t("...Read Less") : t("Read More")}
                                                </span>
                                            )}
                                        </p>
                                        {/* <span style={{ fontSize: "16px", color: '#a52444' }}>{pujaDetailsData?.benefits}</span> */}
                                        {/* Puja Price  */}
                                        {(!isRemedy && !isHomam) && (
                                            <div className="price-tag  position-relative align-items-start mb-2 mt-1">
                                                {location.pathname === "/service/puja-details/book-satyanarayan-puja" ? (
                                                   <div className="text-dark px-3  rounded" style={{ background: "#efb423", marginRight: "10px" }}>
                                                        <strong>
                                                            ₹{" "}
                                                            {pujaDetailsData.onlinePujaPrice
                                                                ? formatToIndianCurrency(Math.round(pujaDetailsData.onlinePujaPrice - (pujaDetailsData.onlinePujaDiscountAmount || 0)))
                                                                : formatToIndianCurrency(Math.round(pujaDetailsData.offlinePujaPrice - (pujaDetailsData.offlinePujaDiscountAmount || 0)))}
                                                        </strong>
                                                    </div>
                                                ) : (
                                                    <div className="text-dark px-3  rounded" style={{ background: "#efb423", marginRight: "10px" }}>
                                                        <strong>
                                                            ₹{" "}
                                                            {pujaDetailsData.onlinePujaPrice
                                                                ? formatToIndianCurrency(Math.round(pujaDetailsData.onlinePujaPrice - (pujaDetailsData.onlinePujaDiscountAmount || 0)))
                                                                : formatToIndianCurrency(Math.round(pujaDetailsData.offlinePujaPrice - (pujaDetailsData.offlinePujaDiscountAmount || 0)))}
                                                        </strong>
                                                    </div>
                                                )}
                                                {pujaDetailsData?.pujaDiscount !== null &&
                                                    pujaDetailsData?.pujaDiscount !== undefined &&
                                                    pujaDetailsData?.pujaDiscount !== 0 && (location.pathname !== "/service/puja-details/book-satyanarayan-puja") ? (
                                                    <>
                                                        <span className="original-price">
                                                            ₹ {pujaDetailsData.onlinePujaPrice
                                                                ? formatToIndianCurrency(Math.round(pujaDetailsData.onlinePujaPrice))
                                                                : formatToIndianCurrency(Math.round(pujaDetailsData.offlinePujaPrice))}
                                                        </span>
                                                        <span className="discount-text">
                                                            ({Math.round(Number(pujaDetailsData.pujaDiscount))}% {t("OFF")})
                                                        </span>
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        )}


                                        {/* Short Description */}
                                        {pujaDetailsData?.shortDescription !== null && pujaDetailsData?.shortDescription !== undefined && (
                                            <p className="small mb-3" >
                                                {readMore ? plainText : plainText?.length > maxChars ? `${plainText.substring(0, maxChars)}...` : plainText}
                                                {plainText?.length > maxChars && (
                                                    <span
                                                        onClick={toggleReadMore}
                                                        // className="btn-fancy"
                                                        style={{ color: '#a52444', cursor: 'pointer' }}
                                                    >
                                                        {readMore ? t("...Read Less") : t("Read More")}
                                                    </span>
                                                )}
                                            </p>
                                        )}

                                        {(pujaDetailsData?.pujaSubServiceID !== 5 && pujaDetailsData?.pujaSubServiceID !== 6 && pujaDetailsData?.templeAddress !== undefined && pujaDetailsData?.templeAddress !== null) && (
                                            <>
                                                <div className="d-flex align-items-center">
                                                    <FontAwesomeIcon icon={faLocationDot} size="1x" className="text-yellow-500 " />

                                                    <span className="small">{pujaDetailsData?.templeAddress || 'Nashik'}</span>
                                                    {/* <span className="ms-auto">
                                            {[...Array(5)].map((_, i) => (
                                                <FontAwesomeIcon key={i} icon={faStar} className="text-warning me-1" />
                                            ))}
                                            <span className="small text-muted">(50+)</span>
                                        </span> */}
                                                </div>
                                            </>
                                        )}


                                        {/* Devotees Count */}
                                        {/* <div className="glow-border p-2 my-1 rounded text-center">
                                        <p className="mb-0 fw-bold text-dark">
                                            1025+ Devotees already booked this Puja
                                        </p>
                                    </div> */}




                                        {/* Count Down For Puja  */}
                                        {(pujaDetailsData?.pujaSubServiceID !== 5 && pujaDetailsData?.pujaSubServiceID !== 6 && !isRemedy && !isHomam && pujaDetailsData?.pujaTime !== null && pujaDetailsData?.pujaDate !== null) && (
                                            <>
                                                <p className=" small textdecoration" style={{ marginBottom: "0px", fontSize: "20px" }}>{t("Puja starts in")}</p>
                                                <div className="d-flex align-items-center justify-content-between  ">
                                                    <CountdownTimer
                                                        pujaDate={pujaDetailsData?.pujaDate}
                                                        pujaTime={pujaDetailsData?.pujaTime}
                                                    />



                                                </div>
                                            </>
                                        )}



                                        {/* Participate Button */}
                                        {!isRemedy && !isHomam ? (
                                            <div className='d-flex justify-content-between'>
                                                <Button
                                                    onClick={() => handleProceedToBookClicked()}

                                                    size='lg'
                                                    className="w-50 z-100 rounded-pill  py-1 mt-1 pulse-button  mb-2"
                                                >
                                                    {t("Book Now")}
                                                </Button>

                                                <div className="d-flex align-items-end gap-2">


                                                    {/* Share Button */}
                                                    <Button
                                                        className="icon-btn share-btn" style={{ height: "45px" }}
                                                        onClick={() => sharePujaDetails()}
                                                    >
                                                        <FontAwesomeIcon icon={faShareAlt} />
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="d-flex align-items-center gap-2">
                                                {/* WhatsApp Button */}
                                                {/* <Button
    className="icon-btn whatsapp-btn"
    onClick={() => handleWhatsappClick()}
  >
    <FontAwesomeIcon icon={faWhatsapp} />
  </Button> */}

                                                {/* Share Button */}
                                                <Button
                                                    className="icon-btn share-btn" style={{ height: "45px", width: "auto" }}
                                                    onClick={() => {
                                                        if (navigator.share) {
                                                            navigator.share({
                                                                title: pujaDetailsData?.pujaName,
                                                                text: pujaDetailsData?.shortDescription || '',
                                                                url: window.location.href,
                                                            });
                                                        } else {
                                                            alert("Sharing not supported on this device");
                                                        }
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faShareAlt} />
                                                </Button>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {(isRemedy || isHomam) && (
                            <>
                                <hr />
                                <SankalpPujasPackageList serviceName={isRemedy ? 'Remedy Puja' : 'Homam Puja'} pujaKeyID={pujaDetailsData?.pujaKeyID} setSelectedPackage={setSelectedPackage} />
                            </>
                        )}

                        {/* Tabs Wise Details */}
                        <Row>
                            <LazySection><PujaPageSections pujaDetailsData={pujaDetailsData} FAQ={FAQ} t={t} /></LazySection>
                        </Row>

                        {/* How it Works */}
                        <Row>
                            <LazySection><HowItWorks serviceData={howItWorks} /></LazySection>
                        </Row>

                    </Container >
                    <LazySection> <DownloadApp languageID={selectedLanguageID == 3 ? 1 : null} /></LazySection>
                    {pujaListData?.length > 0 && (

                        <LazySection> <PopularPujas pujaListData={pujaListData} /></LazySection>
                    )}
                </>
            )}




            {totalRecords <= 0 && <NoResultFoundModel totalRecords={totalRecords} />}

            <LoginPopUp show={showLoginModal} onHide={() => setShowLoginModal(false)} onConfirm={handleProceedToBookClicked} />

            <ShareLinkModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                shareUrl={currentUrl}
                message={PujaShareMassage} // Optional
                title="Share puja" // Optional
            />
            <PujaUnavailableModal
                show={showPujaNotAvailableModal}
                onHide={() => setShowPujaNotAvailableModal(false)}
                unavailableMsg={unavailablePujaMsg}
                unavailableMsgHeader={unavailablePujaMsgHeader}
            />

            <ExitIntentModal
                slug={slug}
                show={showExitIntentModal}
                onHide={() => {
                    setShowExitIntentModal(false);
                }}
            />
        </>
    )
}

export default RemedyPujaDetails
